import React from 'react';
import { Breadcrumb } from './Breadcrumb';
import { DeskSearch } from './DeskSearch';
import { ViewHeader } from './ViewHeader';

interface DeskHeaderProps {
  actions?: React.ReactNode;
  showSearch?: boolean;
}

export const DeskHeader: React.FC<DeskHeaderProps> = ({ actions, showSearch = true }) => {
  return (
    <ViewHeader
      pageActions={actions}
      marginBottom="0"
      showSidebarToggle
      centerContent={showSearch ? <DeskSearch /> : undefined}
    >
      <div data-testid="desk-header-title" className="flex min-w-min items-center gap-4">
        <Breadcrumb />
      </div>
    </ViewHeader>
  );
};
